export class RoleAccessFlatModel {
	public id: string;
	public code: string;
	public parentCode: string;
	public description: string;
	public expandable: boolean;
	public level: number;
}
